import {
    FETCHED_ROLES,
    FETCHED_PERMISSIONS,
    FETCHED_ROLES_PERMISSIONS,
    CHANGE_ROLE_PERMISSION,
    UPDATED_ROLES_PERMISSIONS,
    FETCHED_PERMISSIONS_GROUPS
} from "./types";

export function fetchedRoles(roles) {
    return {
        type: FETCHED_ROLES,
        payload: {
            data: roles
        }
    }
}

export function fetchedPermissions(permissions) {
    return {
        type: FETCHED_PERMISSIONS,
        payload: {
            data: permissions
        }
    }    
}

export function fetchedPermissionsGroups(groups) {
    return {
        type: FETCHED_PERMISSIONS_GROUPS,
        payload: {
            data: groups
        }
    }    
}

export function fetchedRolesPermissions(rolesPerms) {
    return {
        type: FETCHED_ROLES_PERMISSIONS,
        payload: {
            data: rolesPerms,
            touched: false
        }
    }
}

export function changeRolePermission(roleId, permId, checked) {
    return {
        type: CHANGE_ROLE_PERMISSION,
        payload: {
            roleId: roleId,
            permId: permId,
            checked: checked,
            touched: true
        }
    }
}

export function updatedRolesPermissions(response) {
    return {
        type: UPDATED_ROLES_PERMISSIONS,
        payload: response,
        touched: false
    }
} 



// WEBPACK FOOTER //
// ./src/containers/roles/actions.js